module.exports = __webpack_public_path__ + "static/img/common_bg_top3@2x.67e5b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/common_bg_top3@2x.png
// module id = gzAh
// module chunks = 37